import React, { useEffect, useState } from 'react';
import './SearchResult.css'
/*import SearchResult from './SearchResult';*/
import Floatbar from '../../components/floatbar/Floatbar';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';

export function SearchResult(){
    const [results, setResults] = useState([]);
    const location = useLocation();

    useEffect(() => {
        const fetchData = async () => {
            const urlSearchParams = new URLSearchParams(location.search);
            let query = urlSearchParams.get('search_query');

            const response = await fetch(`/api/search/?search_query=${query}`);
            const data = await response.json();
            const searchResults = data;
            setResults([...searchResults])
        }
        fetchData();
    }, [location.search]);

    return (

       <>
            <div id="content-container">
                <h1 className="font-1 margin-top-30">Search Result</h1>

                <hr />
                <div className="inline-block-wrapper margin-top-30">
                    <div className="search-result-list-wrapper">
                        {results.length > 0 ? (
                            <ul className="search-result-list">
                                {results.map(result => (
                                    <Link to={`/home/?${result.topicId ? `node=${result.topicId}` : `path=${result.pathId}`}`}>
                                        <li key={result._id}>
                                            {result.name || result.pathName}
                                            {result.pathId != null && (
                                                <span className="suggestions-tag">Path</span>
                                            )}
                                        </li>
                                    </Link>
                                ))}
                            </ul>
                        ) : (
                            <p className="font-2">No results found</p>
                        )}
                    </div>
                    <Floatbar />
                </div>
            </div>
        </>
    );
}
